import { getEndpointUrl } from '@isoapp/common/platform/env/constants/endpoints'
import { setClientConfig } from '@isoapp/common/platform/networking/client/setClientConfig'
import type { GraphQlServiceType } from '@isoapp/common/platform/networking/types/serviceType'

export function initClient() {
  setClientConfig({
    utilities: {
      getAuthHeaders,
      getClientHeaders,
      getServiceUrl,
    },
  })
}

async function getAuthHeaders(): Promise<Record<string, string>> {
  const token = await shopify.idToken().catch(() => null)
  if (!token) {
    return {}
  }

  return {
    Authorization: `Bearer ${token}`,
  }
}

function getClientHeaders(): Promise<Record<string, string>> {
  return Promise.resolve({})
}

function getServiceUrl(service: GraphQlServiceType): string {
  if (service !== 'graph') {
    throw new Error(`Shopify client only supports graph service, received: ${service}`)
  }

  return `${getEndpointUrl(service)}/graphql`
}
